import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EcommerceService } from 'src/app/services/ecommerce.service';

@Component({
  selector: 'app-add-products-editor',
  templateUrl: './add-products-editor.component.html',
  styleUrls: ['./add-products-editor.component.scss']
})
export class AddProductsEditorComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public listItemdata: any,
    public dialogRef: MatDialogRef<AddProductsEditorComponent>,
    public ecommerceService: EcommerceService) {
  }
  data: any;
  listItems: any;
  searchProducts: string = '';
  ngOnInit() {
    if (this.listItemdata) {
      this.data = this.listItemdata.video
      this.listItems = this.listItemdata.videoList
    }
    this.getAllProducts();
  }
  closeDialog() {
    this.dialogRef.close();
  }
  listProducts: any[] = [];
  getAllProducts() {
    const payload = { "businessId": localStorage.getItem('businessId') || "1f1000b0-20a9-6a3c-9d23-338d9e082788", "pageNo": 0, "pageSize": 1000, "request": "BUSINESS" }
    this.ecommerceService.getAllProducts(payload).subscribe((res: any) => {
      this.listProducts = res.data.data;
      this.allProductsList = this.listProducts;
      this.listProducts.forEach((product: any) => {
        product.isSelected = false;
        product.redirectionUrl = '';
        product.quantity = 0;
      })
      if (this.listItemdata.video.video.products.length > 0) {
        const selectedProductMap = new Map(
          this.listItemdata.video.video.products.map((p: any) => [
            p.itemId,
            {
              isSelected: p.isSelected,
              redirectionUrl: p.redirectionUrl
            }
          ])
        );

        // Step 3: update API products
        this.listProducts.forEach((product: any) => {
          if (selectedProductMap.has(product.itemId)) {
            const mappedData: any = selectedProductMap.get(product.itemId);
            product.isSelected = mappedData.isSelected;
            product.redirectionUrl = mappedData.redirectionUrl;
          }
        });
        this.selectedProducts = this.listItemdata.video.video.products;
      }
      console.log("selected products", this.listProducts);
    })
  }
  allProductsList: any[] = [];
  selectedTab: string = 'Selection';
  selectedProducts: any[] = [];
  selectProduct(product: any) {
    product.isSelected = !product.isSelected

    if (product.isSelected) {
      // add product
      this.selectedProducts.push(product);
    } else {
      // remove product
      this.selectedProducts = this.selectedProducts.filter(
        selectedProduct => selectedProduct.itemId !== product.itemId
      );
    }
  }
  addProducts() {
    this.dialogRef.close({ selectedProducts: this.selectedProducts })
  }
  searchListProducts() {
    if (this.searchProducts.length > 2) {
      this.listProducts = this.listProducts.filter((product: any) => product.name.includes(this.searchProducts));
    }
    else {
      this.listProducts = this.allProductsList;
    }
  }
}
